<template>
  <div class="cms-section-item-list">
    <ul class="u-reset cms-section-item-list__item-list">
      <li
        v-for="(sectionItem, sectionItemIdx) in sectionItemList"
        :key="sectionItemIdx"
        class="cms-section-item-list__item"
      >
        <cms-section-item :component-item-list="sectionItem.cmsSectionItem.cmsComponentItemList" />
      </li>
    </ul>
  </div>
</template>

<script>
  import CmsSectionItem from '@/components/cms/cms-section-item/cms-section-item'

  export default {
    components: { CmsSectionItem },
    props: {
      sectionItemList: {
        type: Array,
        required: true,
      },
    },
  }
</script>

<style lang="scss" src="./_cms-section-item-list.scss" />
